import { MODULE_NAME } from '../constants';

export const GET_STORE = `${MODULE_NAME}/GET_STORE`;
export const GET_STORE_SUCCESS = `${MODULE_NAME}/GET_STORE_SUCCESS`;
export const GET_STORE_ERROR = `${MODULE_NAME}/GET_STORE_ERROR`;
